import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={21}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m3.467 8.89 3.684 6.23C10.97 9.158 15.257 3.932 19.143.918c.87-.804 2.21-.335 1.273.536-4.355 4.488-7.704 9.58-11.12 17.552-1.34.937-2.882 1.406-3.619.535L.854 10.9c-.67-1.071 1.675-3.55 2.613-2.01Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;
